import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ACLService } from '@delon/acl';
import { FcwidgetService } from 'src/app/core/util/fcwidget.service';
import { QUINNY_AI_AVATAR_URL } from '@core';
import { QuinnyN3RedirectService } from '../../../../shared/services/quinny-n3-redirect.service';

@Component({
  selector: 'header-chat',
  templateUrl: './quinny-ai.component.html',
  styleUrls: ['./quinny-ai.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class HeaderQuinnyAIComponent {
  readonly quinnyAiAvatarUrl = QUINNY_AI_AVATAR_URL;
  readonly noPermissionTip = 'You do not have permission';

  constructor(
    private fcWidget: FcwidgetService,
    private acl: ACLService,
    private quinnyN3Redirect: QuinnyN3RedirectService
  ) {}

  get canViewReportCenter(): boolean {
    return this.acl.canAbility('report.view');
  }

  get canViewReportDesigner(): boolean {
    return this.acl.canAbility('reportfile.view');
  }

  openChat() {
    const chatbot = document.getElementById('chatbot-window');
    if (chatbot?.classList.contains('visible')) {
      chatbot.classList.toggle('visible');
    }
    this.fcWidget.openWithUserContext();
  }

  navigateToAI(route: string) {
    void this.quinnyN3Redirect.openOrNavigate(route);
  }

  async openQuinnyAI(event: MouseEvent) {
    const syncDecision = this.quinnyN3Redirect.shouldRedirectToN3Sync();
    const shouldRedirect =
      syncDecision !== null
        ? syncDecision
        : await this.quinnyN3Redirect.shouldRedirectToN3();

    if (!shouldRedirect) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();
    this.navigateToAI('/ai/copilot');
  }
}
